import ranges from './ranges.js'

var segments = Object.keys(ranges)

export default segments
